import { ajax } from "@/plugins/ajax";

export default {
  namespaced: true,
  state: {
    list: []
  },
  getters: {
    list: state => state.list
  },
  actions: {
    fetch({ commit, dispatch }) {
      return ajax
        .get("ProductManagement/api/ProductColorsQuery?Take=100&Skip=0")
        .then(() => {});
    },
    fetchMinify({ commit, dispatch }) {
      return ajax.get("ProductManagement/api/ProductColorsQuery/0").then(r => {
        commit("setList", r.data);
      });
    },
    create({ commit, dispatch }, model) {
      return ajax
        .post("ProductManagement/api/ProductColors", model)
        .then(() => {});
    },
    remove({ commit, dispatch }, id) {
      return ajax
        .delete(
          "ProductManagement/api/ProductColors",
          { data: { id: id } },
          { headers: { "Content-Type": "application/json" } }
        )
        .then(() => {});
    },
    update({ commit, dispatch }, model) {
      return ajax
        .put("ProductManagement/api/ProductColors", model)
        .then(() => {});
    }
  },
  mutations: {
    setList(state, data) {
      state.list = data;
    }
  }
};
